import { renderFloorPlanGrid } from './floorPlanCards.dom';
import prioritizePlans from '../services/planPriorityService';

function renderNewFloorPlansSummary(newFloorPlansCount) {
	return `
		<section class="nhs-c-native-interactive-site-map__new-floor-plans-summary" data-qa="native_ism_new_floor_plans_summary">
			<p class="nhs-c-native-interactive-site-map__new-floor-plans-label nhs-mq-native-interactive-site-map__new-floor-plans-label-medium nhs-o-typography--sans-label-1-extra-extra-small-regular">NEW FLOOR PLANS</p>
			<p class="nhs-c-native-interactive-site-map__new-floor-plans-count nhs-mq-native-interactive-site-map__new-floor-plans-count-medium nhs-o-typography--sans-body-1-medium-regular">${newFloorPlansCount}</p>
		</section>
	`;
}

function renderGetNotifiedButton(community) {
	return `
	<div class="nhs-c-native-interactive-site-map__get-notified-button nhs-mq-native-interactive-site-map__get-notified-button-medium" data-card>
		<button
			class="nhs-c-button--primary-lead nhs-c-button--medium-40 nhs-c-button--text-only nhs-u-width--full"
			data-get-notified-button
			data-lead-generator-opener="get-on-the-list"
			data-from-page="CommunityDetail.NativeInteractiveSiteMap.CommunityComingSoon"
			data-id="${community?.communityId ?? ''}"
			data-type="community"
			data-variation="information"
			data-exclude-recommendations="true"
			data-community-id="${community?.communityId ?? ''}"
			data-community-name="${community?.communityName ?? ''}"
			data-market-id="${community?.marketId ?? ''}"
			data-market-name="${community?.marketName ?? ''}"
			data-brand-name="${community?.brandName ?? ''}"
			data-qa="native_ism_get_notified_button">
				Get notified when available
		</button>
	</div>
	`;
}

/**
 * Renders the Coming Soon panel: a summary of new floor plans, the sorted floor-plan grid,
 * and a "Get Notified" CTA.
 * @param {Object[]} cards - Floor-plan card list.
 * @param {Object} options - Rendering options.
 * @param {number} options.newFloorPlansCount - Count shown in the summary.
 * @param {Set<number>} [options.priorityPlanIds] - Plan ids to lead the grid with (the selected
 *   lot's relevant plans, per NHS20-8167). Defaults to an empty Set, which leaves the grid
 *   byte-for-byte the same alphabetical order as before this option existed.
 * @param {Object} [options.community] - Community context for the "Get Notified" CTA.
 * @returns {string} HTML string for panel content.
 */
export default function renderComingSoonPanel(cards = [], options = {}) {
	const {
		newFloorPlansCount = cards.length,
		priorityPlanIds = new Set(),
		community,
	} = options;

	// NHS20-8173: Floor plans are sorted alphabetically by PlanName within each group.
	// NHS20-8167: the selected lot's relevant plans (priorityPlanIds) lead the grid.
	const sortedCards = prioritizePlans(cards, priorityPlanIds);

	return `
	${renderNewFloorPlansSummary(newFloorPlansCount)}
	${renderFloorPlanGrid(sortedCards)}
	${renderGetNotifiedButton(community)}
	`;
}
